<script lang="typescript">
    export let text: string = "H5/Roboto/Regular/24px";
    export let color = "var(--color-level-7)";
</script>

<h5 style="color: {color};" class="headline5">{text}</h5>

<style>
    .headline5 {
        /* Headline 5 */
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 24px;
        /* identical to box height, or 100% */
        letter-spacing: 0.18px;

    }
</style>
